import {
  AlertSize,
  AlertVariants,
  BlockAlert,
  CalendarIcon,
  PayrollIcon,
} from '../../../components';
import { formatEta, formatFee } from '../../../utils/format';
import { TaskSourceRequirement } from '../utils/types';

interface FeesAndEtaProps {
  fee: TaskSourceRequirement['fee'];
  eta: TaskSourceRequirement['eta'];
}

export const FeesAndEta = ({ fee, eta }: FeesAndEtaProps) => {
  const formattedFee = fee && formatFee(fee);
  const formattedEta = eta?.estimation && formatEta(eta.estimation);

  if (formattedFee || formattedEta) {
    return (
      <BlockAlert variant={AlertVariants.Info} size={AlertSize.Medium}>
        <div className="space-y-2">
          {formattedFee && (
            <div className="flex items-center gap-x-2">
              <PayrollIcon className="size-6 shrink-0" />

              <span>
                <strong>{formattedFee.value} Estimated State Fees</strong> –
                passed through to your account if you automate
              </span>
            </div>
          )}

          {formattedEta && (
            <div className="flex items-center gap-x-2">
              <CalendarIcon className="ml-0.5 size-5" />

              <span>
                <strong>
                  {formattedEta.value} {formattedEta.unit}
                </strong>{' '}
                – estimated processing time
              </span>
            </div>
          )}
        </div>
      </BlockAlert>
    );
  }

  return null;
};
